import React, { useEffect, useState, useRef } from "react";
import backgroundimg from "./../image/banner.png";
import { Link } from "react-router-dom";
import { useStateValue } from "../context/StateProvider";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { addDoc, collection } from "firebase/firestore";
import { firestore } from "../firebase.config";

const Partners = () => {
  const [{ Company }] = useStateValue();
  const scrollRef = useRef(null);
  const [showButtons, setShowButtons] = useState(true);

  // Form State
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    city: "",
    state: "",
    companyName: "",
    sellingIT: "",
  });

  // Validation State
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setShowButtons(false); // Hide buttons on small screens
      } else {
        setShowButtons(true); // Show buttons on larger screens
      }
    };

    handleResize(); // Initial check on load
    window.addEventListener("resize", handleResize); // Listen for window resize

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const autoScroll = setInterval(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollBy({ left: 200, behavior: "smooth" });
      }
    }, 3000); // Change the interval time as needed (3 seconds in this example)

    return () => clearInterval(autoScroll); // Clean up the interval on unmount
  }, []);

  // Handles input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    // Real-time validation
    if (name === "firstName") {
      if (value.trim().length > 0 && value.trim().length < 3) {
        setErrors({ ...errors, firstName: "First Name must be at least 3 letters" });
      } else {
        setErrors({ ...errors, firstName: "" });
      }
    } else if (name === "lastName") {
      if (value.trim().length === 0) {
        setErrors({ ...errors, lastName: "Last Name is required" });
      } else {
        setErrors({ ...errors, lastName: "" });
      }
    } else if (name === "email") {
      if (value.trim() === "") {
        setErrors({ ...errors, email: "Email is required" });
      } else if (!/^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/.test(value)) {
        setErrors({ ...errors, email: "Invalid Email format" });
      
      } else {
        setErrors({ ...errors, email: "" });
      }
    } else if (name === "phone") {
      if (value.trim() === "") {
        setErrors({ ...errors, phone: "Phone Number is required" });
      } else if (!/^\d{10}$/.test(value)) {
        setErrors({ ...errors, phone: "Enter a valid 10-digit phone number" });
      } else {
        setErrors({ ...errors, phone: "" });
      }
    } else if (name === "city") {
      if (value.trim() === "") {
        setErrors({ ...errors, city: "City is required" });
      } else {
        setErrors({ ...errors, city: "" });
      }
    } else if (name === "state") {
      if (value.trim() === "") {
        setErrors({ ...errors, state: "State is required" });
      } else {
        setErrors({ ...errors, state: "" });
      }
    } else if (name === "companyName") {
      if (value.trim() === "") {
        setErrors({ ...errors, companyName: "Company Name is required" });
      } else {
        setErrors({ ...errors, companyName: "" });
      }
    } else if (name === "sellingIT") {
      if (!value) {
        setErrors({ ...errors, sellingIT: "Please select an option" });
      } else {
        setErrors({ ...errors, sellingIT: "" });
      }
    }
  };

  // Validation function (primarily for submit button)
  const validateForm = () => {
    let newErrors = {};
    let isValid = true;

    if (!formData.firstName.trim()) {
      newErrors.firstName = "First Name is required";
      isValid = false;
    } else if (formData.firstName.trim().length < 3) {
      newErrors.firstName = "First Name must be at least 3 letters";
      isValid = false;
    }
    if (!formData.lastName.trim()) {
      newErrors.lastName = "Last Name is required";
      isValid = false;
    }
    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid Email format";
      isValid = false;
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "Phone Number is required";
      isValid = false;
    } else if (!/^\d{10}$/.test(formData.phone)) {
      newErrors.phone = "Enter a valid 10-digit phone number";
      isValid = false;
    }
    if (!formData.city.trim()) {
      newErrors.city = "City is required";
      isValid = false;
    }
    if (!formData.state.trim()) {
      newErrors.state = "State is required";
      isValid = false;
    }
    if (!formData.companyName.trim()) {
      newErrors.companyName = "Company Name is required";
      isValid = false;
    }
    if (!formData.sellingIT) {
      newErrors.sellingIT = "Please select an option";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };


  // Handles form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      // Show a general error message if any field is invalid
      toast.error("Please correct the highlighted fields below.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
      return;
    }

    try {
      await addDoc(collection(firestore, "PartnerEnquire"), formData);

      toast.success("Your inquiry has been submitted successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      // Reset form after successful submission
      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        city: "",
        state: "",
        companyName: "",
        sellingIT: "",
      });

      setErrors({});
    } catch (error) {
      toast.error("Something went wrong. Please try again.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  return (
    <div className="w-full mx-w-[1400px] h-auto bg-white flex flex-col items-center justify-center lg:mt-20 sm:mt-0">
      <Helmet>
        <title>Our Partners - Nexify Infosystms</title>
        <meta
          name="description"
          content="Explore our partners at Nexify and discover how we collaborate with businesses to deliver customized solutions."
        />
        <meta
          name="keywords"
          content="Nexify, partners, collaboration, business solutions, technical partners, growing together"
        />
      </Helmet>
      {/* Header Section */}
      <div
        className="w-full h-[440px] bg-cover bg-center relative flex items-center justify-center"
        style={{ backgroundImage: `url(${backgroundimg})` }}
      >
        <div className="relative z-0 flex justify-center lg:justify-start items-center w-full px-4 sm:px-10 lg:px-20">
          <div
            className="opacity-0 translate-y-10 animate-slideUp bg-[#0e55a8] p-6 shadow-lg text-white inline-block text-center lg:text-left max-w-[90%] sm:max-w-[80%] md:max-w-[60%] lg:max-w-[60%] lg:ml-14 border border-white/20 rounded-lg relative"
            style={{
              animation: "slideUp 1s ease-in-out forwards",
              animationDelay: "2s",
            }}
          >
            {/* 🔵 Dot Pattern Overlay Inside Box */}
            <div className="absolute inset-0 bg-[radial-gradient(circle,_rgba(255,255,255,0.2)_1px,_transparent_1px)] bg-[size:6px_6px] opacity-50 pointer-events-none rounded-lg"></div>

            <h1 className="text-[8vw] md:text-[66px] font-semibold mb-2 break-words">
              Nexify Partner Program
            </h1>
            <h2 className="text-[5vw] md:text-[40px] text-[#efefef]">
              Grow your business by partnering with Nexify
            </h2>
          </div>
        </div>
      </div>

      {/* Partners Section */}
      <div className="bg-white flex flex-col items-left text-left p-6 w-full max-w-[1200px] mt-5 gap-6 mb-20">
        <h2 className="lg:text-[40px] text-2xl font-semibold text-[#005eb8]">
          Join the Nexify Partner Program
        </h2>
        <p className="text-[#6d6d70] font-[400] text-[16px] leading-[1.8]">
          Nexify is an E-Verify company, and we are excited to collaborate with
          businesses to develop customized solutions that align with their
          unique requirements as they grow. Below are some of our valued
          technical partners.
        </p>
        <div className="relative w-full mt-2 lg:mt-0">
          <h2 className="text-[#0e55a8] text-[30px] font-[700] text-center">
            Our Trusted Partners
          </h2>
          <div
            ref={scrollRef}
            className="lg:w-full flex items-center justify-start lg:justify-center gap-2 lg:gap-24 lg:py-6 overflow-x-auto scrollbar-none md:overflow-x-scroll"
          >
            {Company && Company.length > 0 ? (
              Company.map((brand) => (
                <motion.div
                  whileHover={{ scale: 1.1 }}
                  key={brand.id}
                  className="flex flex-col items-center bg-white p-2"
                >
                  <div className="w-24 h-24 md:w-32 md:h-32 lg:w-32 lg:h-32 overflow-hidden">
                    <img
                      src={brand.imageurl}
                      alt={brand.title}
                      className="w-full h-full object-contain"
                    />
                  </div>
                </motion.div>
              ))
            ) : (
              <p>No Partner available</p>
            )}
          </div>
        </div>
        <div className="relative w-full mt-2 lg:mt-0 p-6 bg-[#f9f9f9] shadow-lg rounded-lg max-w-[550px] mx-auto">
          <h2 className="text-[#0e55a8] text-[30px] font-[700] text-center">
            Let's Touch Base
          </h2>
          <p className="leading-[1.8] text-center text-[16px] text-[#222]">
            Please complete the form below, and our channel team will reach out
            to you within 24-48 hours.
          </p>

          <form className="mt-6" onSubmit={handleSubmit}>
            {/* First Name & Last Name */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <input
                type="text"
                placeholder="First Name"
                className={`w-full p-3 border rounded-lg ${
                  errors.firstName ? "border-red-500" : ""
                }`}
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
              />
              {errors.firstName && (
                <p className="text-red-500 text-xs italic">
                  {errors.firstName}
                </p>
              )}
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                className={`w-full p-3 border rounded-lg ${
                  errors.lastName ? "border-red-500" : ""
                }`}
              />
              {errors.lastName && (
                <p className="text-red-500 text-xs italic">{errors.lastName}</p>
              )}
            </div>

            {/* Other Fields */}
            <div className="grid grid-cols-1 gap-4 mt-4">
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                className={`w-full p-3 border rounded-lg ${
                  errors.email ? "border-red-500" : ""
                }`}
              />
              {errors.email && (
                <p className="text-red-500 text-xs italic">{errors.email}</p>
              )}
              <input
                type="tel"
                name="phone"
                maxLength={10}
                placeholder="Phone Number"
                value={formData.phone}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                  setFormData({ ...formData, phone: value });
                  setErrors({ ...errors, phone: "" });
                }}
                className={`w-full p-3 border rounded-lg ${
                  errors.phone ? "border-red-500" : ""
                }`}
              />
              {errors.phone && (
                <p className="text-red-500 text-xs italic">{errors.phone}</p>
              )}

              <input
                type="text"
                name="city"
                placeholder="City"
                value={formData.city}
                onChange={handleChange}
                className={`w-full p-3 border rounded-lg ${
                  errors.city ? "border-red-500" : ""
                }`}
              />
              {errors.city && (
                <p className="text-red-500 text-xs italic">{errors.city}</p>
              )}
              <input
                type="text"
                name="state"
                placeholder="State"
                value={formData.state}
                onChange={handleChange}
                className={`w-full p-3 border rounded-lg ${
                  errors.state ? "border-red-500" : ""
                }`}
              />
              {errors.state && (
                <p className="text-red-500 text-xs italic">{errors.state}</p>
              )}
              <input
                type="text"
                name="companyName"
                placeholder="Company Name"
                value={formData.companyName}
                onChange={handleChange}
                className={`w-full p-3 border rounded-lg ${
                  errors.companyName ? "border-red-500" : ""
                }`}
              />
              {errors.companyName && (
                <p className="text-red-500 text-xs italic">
                  {errors.companyName}
                </p>
              )}
            </div>

            {/* Radio Buttons */}
            <div className="mt-4">
              <p className="text-[16px] font-semibold text-[#222]">
                Are you currently selling Managed IT and Security Solutions?*
              </p>
              <div className="flex  items-center gap-6 mt-2">
                <label className="flex flex-col items-center">
                  <input
                    type="radio"
                    name="sellingIT"
                    className="mr-2"
                    value="Yes"
                    checked={formData.sellingIT === "Yes"}
                    onChange={handleChange}
                  />
                  Yes
                </label>
                <label className="flex flex-col items-center">
                  <input
                    type="radio"
                    name="sellingIT"
                    className="mr-2"
                    value="No"
                    checked={formData.sellingIT === "No"}
                    onChange={handleChange}
                  />
                  No
                </label>
              </div>
              {errors.sellingIT && (
                <p className="text-red-500 text-xs italic">
                  {errors.sellingIT}
                </p>
              )}
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              className="w-full mt-6 p-3 bg-[#fb9d3d] text-white text-[16px] font-semibold rounded-lg hover:bg-[#fb9d3d] transition"
            >
              LET'S TALK
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Partners;
